export default __webpack_public_path__ + "static/fonts/Turquoise-Regular.8b059e8.woff2";